import React from 'react'
import { Button } from '@blueprintjs/core'

function SortButton<SortKey extends string>({
  sortBy,
  currentSortKey,
  invertedSort,
  heading,
  sortKey,
}: {
  sortBy: (value: SortKey) => void
  currentSortKey: SortKey
  invertedSort: boolean
  heading: string
  sortKey: SortKey
}) {
  return (
    <Button
      style={{
        maxWidth: '100%',
        width: 'fit-content',
        placeContent: 'flex-start',
      }}
      rightIcon={
        currentSortKey === sortKey
          ? invertedSort
            ? 'chevron-down'
            : 'chevron-up'
          : 'blank'
      }
      intent={currentSortKey === sortKey ? 'primary' : 'none'}
      minimal
      onClick={() => sortBy(sortKey)}
    >
      {heading}
    </Button>
  )
}

export default SortButton
